import React from 'react';
import InnerHTML from '@Components/InnerHTML';

export function SubstanceCommercialSupplierInformationCellPurity(props) {
  const { purityValue, purityText } = props;
  return (
    <InnerHTML
      tag="td"
      className="column-purity"
      html={purityValue ? purityValue + '%' : purityText}
    />
  );

}
